import model from "./model";
import { showNotification } from "./management/notifications-management";
import { fetchResource } from "./services/web-res-service";
import type { CategoryID } from "./types/category-id-types";
import { getLangText, redeemLangObj } from "./utils/utils";
import { navigateTo } from "./management/view-navigation-management";
import { sendUserLoginRequest } from "./services/casino/casino-login-service";
import { sendLoadUserRequest } from "./services/casino/casino-user-data-service";

export default {
    async openTermsAndCond(){
        return await loadLegalDoc('terms-and-conditions');
    },
    async openPrivacyPolicy(){
        return await loadLegalDoc('privacy-policy');
    },
    async navigateTo(viewId: CategoryID){
        return await navigateTo(viewId);
    },
    openChat(){
        if(window.initZendesk) {
            const disposable = model.on('ZendeskLoaded', () => { 
                disposable();
                onShow();
            });
            window.initZendesk();
            return;
        }

        onShow();
        function onShow(){
            window?.$zopim?.livechat?.window?.show?.();
        }
    },
    loginUser(username: string, pass: string){
        if(model.uToken){
            model.dispatch('GetStoredPass', {
                detail: { pass },
            });
            return;
        }

        model.storedUsername = username;
        sendUserLoginRequest(model.storedUsername, pass, false);
    },
    onUserVerificationComplete(){
        sendLoadUserRequest();
    },
    showCashierReceipt(){
        model.dispatch('ClosePaymentWindow');
    },
};

async function loadLegalDoc(id: CategoryID){
    let page = model.clientConfig.webRes?.pages?.find(x => x.id == id);
    if(!page?.path) return;

    let textHtml = await fetchResource(redeemLangObj(page.path), 'text', true);
    if(typeof textHtml !== 'string') return;

    let html = new DOMParser().parseFromString(textHtml, 'text/xml');
    let content = html.querySelector('html')?.innerHTML;

    showNotification({
        title: getLangText(page.label),
        text: content,
    });
}